import { createSvgIcon } from "@mui/material";

export const AccountIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path d="M13.125 5C13.125 6.72473 11.7247 8.125 10 8.125C8.27527 8.125 6.87501 6.72473 6.87501 5C6.87501 3.27527 8.27527 1.875 10 1.875C11.7247 1.875 13.125 3.27527 13.125 5V5M3.75084 16.765C3.80655 13.3535 6.58802 10.6171 10 10.6171C13.412 10.6171 16.1935 13.3535 16.2492 16.765C14.2887 17.664 12.1568 18.1279 10 18.125C7.77001 18.125 5.65334 17.6383 3.75084 16.765H3.75084" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'AccountIcon'
)
